<template>
  <div class="bg-ice-100 p-5 rounded">
    <div class="flex mb-4">
      <svg
        v-for="n in 5"
        :key="n"
        class="mr-1 text-teal-200 fill-current"
        width="16"
        height="16"
      >
        <path
          d="M7.533 1.826a.5.5 0 01.932 0l1.45 3.712a.5.5 0 00.436.318l3.978.23a.5.5 0 01.288.887l-3.083 2.525a.5.5 0 00-.167.513l1.01 3.855a.5.5 0 01-.754.548L8.27 12.262a.5.5 0 00-.54 0l-3.354 2.152a.5.5 0 01-.754-.548l1.01-3.855a.5.5 0 00-.167-.513L1.381 6.973a.5.5 0 01.288-.886l3.978-.231a.5.5 0 00.437-.318l1.45-3.712z"
        />
      </svg>
    </div>
    <p class="mb-3 text-base text-charcoal-400">
      {{
        $t('components.reviewsSummaryCard.message', {
          averageRating,
          totalReviews,
        })
      }}
    </p>
    <a
      class="inline-block"
      href="https://www.reviews.io/company-reviews/store/safewill"
      target="_blank"
    >
      <svg
        width="132"
        height="18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.161 9.094c2.174 0 3.727-1.118 3.727-2.981v-.041c0-1.78-1.367-2.858-3.706-2.858H23.71v5.88h4.451zm-6.086-6.563c0-.455.373-.828.808-.828h5.424c1.779 0 3.208.538 4.12 1.45.703.703 1.117 1.718 1.117 2.857l-.001.04c0 2.381-1.615 3.768-3.872 4.203l3.603 4.638c.166.185.269.372.269.6 0 .435-.414.808-.828.808-.332 0-.58-.187-.766-.436l-4.079-5.299h-4.16v4.906a.83.83 0 01-.828.829.827.827 0 01-.808-.829V2.531h.001zM36.834 15.367V2.531c0-.455.373-.828.807-.828h9.006c.413 0 .746.332.746.746a.743.743 0 01-.746.745H38.47v4.947h7.246c.415 0 .746.352.746.746a.742.742 0 01-.745.745h-7.247v5.072h8.281c.414 0 .745.332.745.745 0 .414-.33.746-.745.746h-9.108a.827.827 0 01-.808-.828M55.158 15.683l-5.59-12.898a.758.758 0 01-.083-.372c0-.414.373-.807.83-.807.413 0 .703.268.848.62l5.01 12.007 5.03-12.048c.145-.29.435-.58.807-.58a.805.805 0 01.746 1.118l-5.61 12.96c-.187.414-.477.684-.953.684h-.083c-.476 0-.786-.27-.952-.684M65.834 2.434c0-.456.373-.828.807-.828a.83.83 0 01.828.828v13.042a.83.83 0 01-.828.829.827.827 0 01-.807-.829V2.434zM71.51 15.367V2.531c0-.455.373-.828.807-.828h9.007c.413 0 .745.332.745.746a.743.743 0 01-.745.745h-8.178v4.947h7.245c.415 0 .746.352.746.746 0 .414-.33.745-.746.745h-7.245v5.072h8.281c.413 0 .745.332.745.745a.742.742 0 01-.745.746h-9.11a.826.826 0 01-.806-.828M84.293 2.806a1.204 1.204 0 01-.082-.373c0-.435.393-.827.848-.827.414 0 .725.31.849.682l3.996 11.511 3.788-11.552c.124-.373.373-.641.807-.641h.105c.413 0 .682.268.806.641L99.198 13.8l4.017-11.552c.125-.373.393-.641.787-.641.434 0 .828.392.828.807 0 .124-.063.269-.103.393l-4.638 12.876c-.145.414-.434.705-.85.705h-.123c-.413 0-.704-.29-.848-.705L94.499 4.545l-3.747 11.137c-.144.414-.434.705-.848.705h-.124c-.415 0-.705-.27-.85-.705L84.294 2.806zM106.888 14.468a.74.74 0 01-.311-.621c0-.456.353-.808.788-.808.206 0 .393.083.496.186 1.366 1.16 2.733 1.72 4.576 1.72 1.945 0 3.229-1.036 3.229-2.465v-.041c0-1.346-.725-2.111-3.767-2.753-3.334-.725-4.866-1.801-4.866-4.183v-.04c0-2.278 2.008-3.955 4.761-3.955 1.906 0 3.292.476 4.617 1.429.166.124.352.352.352.662a.786.786 0 01-.786.787.761.761 0 01-.476-.145c-1.222-.89-2.402-1.263-3.748-1.263-1.884 0-3.085 1.035-3.085 2.34v.04c0 1.368.746 2.133 3.934 2.817 3.229.704 4.72 1.883 4.72 4.098v.042c0 2.484-2.07 4.099-4.947 4.099-2.112 0-3.872-.663-5.487-1.946M119.768 14.566c.312-.001.544.23.544.543v.232a.54.54 0 01-.544.556.542.542 0 01-.556-.556v-.232c0-.313.232-.544.556-.544M122.245 10.238a.45.45 0 01.44-.452c.255 0 .452.196.452.452v5.2a.435.435 0 01-.441.45.445.445 0 01-.451-.451v-5.2zm-.081-2.27c0-.29.232-.475.521-.475.301 0 .532.186.532.476v.15c0 .278-.231.474-.532.474-.289 0-.521-.196-.521-.474v-.15zM130.166 12.866v-.024c0-1.285-.961-2.34-2.223-2.34-1.297 0-2.189 1.055-2.189 2.318v.022c0 1.285.95 2.328 2.213 2.328 1.296 0 2.199-1.043 2.199-2.304zm-5.326 0v-.024c0-1.69 1.32-3.127 3.127-3.127 1.794.001 3.114 1.414 3.114 3.105v.022a3.108 3.108 0 01-3.138 3.126c-1.794 0-3.103-1.412-3.103-3.102"
          fill="#000"
        />
        <path
          d="M0 9a9 9 0 1018 0A9 9 0 000 9zm6.422 1.128L2.25 7.013h5.064l1.678-5.065 1.694 5.065h5.063l-4.157 3.13 1.633 5.157-4.233-3.25-4.203 3.25 1.633-5.172z"
          fill="url(#reviews-io-gradient)"
        />
        <defs>
          <linearGradient
            id="reviews-io-gradient"
            x1="9"
            y1="18"
            x2="9"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#33C886" />
            <stop offset="1" stop-color="#12CF6C" />
          </linearGradient>
        </defs>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ComponentsReviewsSummaryCard',
  data() {
    return {
      averageRating: 0,
      totalReviews: 0,
    };
  },
  async mounted() {
    const merchantReviewData = await this.$http.$get(
      'https://api.reviews.io/merchant/reviews?store=safewill&rating=5&per_page=15&order=desc'
    );
    const thirdPartyReviewData = await this.$http.$get(
      'https://api.reviews.io/third-party/reviews?store=safewill&limit=15&order=desc'
    );

    this.averageRating = parseFloat(
      merchantReviewData.stats.average_rating,
      10
    );
    this.totalReviews = thirdPartyReviewData.stats.total_reviews;
  },
};
</script>
